
import type { PropType } from 'vue'
import type { RegularFilter } from '../../models/store/filters/filter'
import type { RegularFilterSelectedValues } from '../../models/store/filters/filter-selected-values'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import RegularFilterSelectorRounded from '../../components/filters/regular-filter-selector-rounded.component.vue'
import { mapActions } from '../../composables/utils'
import { CONTEXT_CONSTS } from '../../store/context/context.consts'

export default defineComponent({
  name: 'ExplainFilters',
  components: {
    RegularFilterSelectorRounded,
  },
  props: {
    filters: {
      type: Object as PropType<Record<string, RegularFilter>>,
      required: true,
    },
  },
  setup: props => {
    const {
      proxy: { $store },
    } = getCurrentInstance()
    const { setFiltersSelectedValues } = mapActions($store, CONTEXT_CONSTS.moduleName, {
      setFiltersSelectedValues: CONTEXT_CONSTS.actions.setFiltersSelectedValues,
    })

    const visibleFilters = computed(() =>
      Object.fromEntries(
        Object.values(props.filters)
          .filter((filter: RegularFilter) => filter.config.values.length > 1)
          .map((filter: RegularFilter) => [filter.config.id, filter]),
      ),
    )

    async function onFiltersSelectedValuesChange(
      filter: RegularFilter,
      selectedValues: RegularFilterSelectedValues,
    ) {
      await setFiltersSelectedValues({
        [filter.config.id]: selectedValues,
      })
      this.$emit('contextChanged')
    }

    return { baseClass: 'epb-explain-filters', onFiltersSelectedValuesChange, visibleFilters }
  },
})
